export default "__VITE_ASSET__BwRlVUP4__"